<div class="wrapper-billing">
  <!-- Phones: the editor is not available. On phone widths this replaces
       everything else here (styles-mobile.scss); Back goes where the header's
       back arrow goes (Pages, or Design for the home page). -->
  <div class="mobile-editor-block">
    <span class="mobile-editor-block-icon"><i class="fi fi-rr-computer"></i></span>
    <h2 class="mobile-editor-block-title">{{ "Open on a computer" | translate }}</h2>
    <p class="mobile-editor-block-text">
      {{ "Landing pages and the HTML home page can only be created and edited on a computer. The editor isn't available on mobile." | translate }}
    </p>
    <button type="button" class="mobile-editor-block-btn" [routerLink]="exitRoute">
      <i class="fi fi-rr-arrow-small-left"></i>
      {{ "Back" | translate }}
    </button>
  </div>

  <!-- DEV / DEBUG: wizard/form state panel (global reusable component). -->
  <app-debug-state
    [state]="debugState"
    title="Page Wizard"
    storageKey="page-manage"
  ></app-debug-state>

  <div class="section-title fixed row w-full flex z-[8]">
    <div class="section-main section-btn">
      <button [routerLink]="exitRoute" class="btn btn-back" [attr.aria-label]="'Back' | translate">
        <div class="arrow-wrap">
          <i class="fi-rr-arrow-alt-left"></i>
        </div>
      </button>
    </div>

    <div class="inline-flex items-center">
      <div class="title">{{ dashboardPageTitle | translate }}</div>

      <div class="save-button-group inline-flex fixed right-5">
        <button
          *ngIf="!fullPageMode && !htmlPreviewFullscreen && showPreviewButton && selectedEditorType === 'html'"
          class="text-indigo-500 hover:!bg-indigo-500 border !border-indigo-500 hover:text-white bg-white font-bold py-2 px-4 rounded transition ease-in-out duration-300 right-3 mr-2"
          [class]="
            customPageIsSaving || !editorIsReady
              ? '!opacity-50 pointer-events-none'
              : ''
          "
          (click)="toggleHtmlPreviewFullscreen()"
        >
          <i class="fi fi-rr-eye mr-2"></i>
          {{ "Preview" | translate }}
        </button>

        <button
          *ngIf="readyToSave || isEditPage"
          class="bg-indigo-500 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded transition ease-in-out duration-300 right-3"
          [ngClass]="
            (isEditPage ? (customPageIsSaving || !editorIsReady || !hasUnsavedChanges) : (customPageIsSaving || !editorIsReady))
              ? '!opacity-50 pointer-events-none'
              : ''
          "
          (click)="updateCustomPage($event, SAVE_BEHAVIOUR.SAVE)"
        >
          {{ "Save" | translate }}
        </button>
      </div>
    </div>
  </div>
  <div class="top-spacing"></div>
  <!-- <div class="pt-5 mt-5 card">
    <pre>{{ customPageData | json }}</pre>
    <pre>{{ selectedTheme }}</pre>
  </div> -->

  <div class="row content-wrapper">
    <div class="col-12">
      <div
        class="loading-spinner"
        *ngIf="customPageIsLoading && selectedEditorType !== 'new'; else loadedContent"
      >
        <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
      </div>
      <ng-template #loadedContent>
        <div class="loading-spinner spinner-style" *ngIf="editPageIsloading">
          <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
        </div>
        <div
          class="content-card"
          [class.editor-active]="selectedEditorType === 'html' && currentStep === 3 && htmlTemplateSelected"
          [style.opacity]="editPageIsloading ? '0.3' : '1'"
        >
          <div class="content-step-indicator">
            <ul class="step-indicator">
              <ng-container *ngFor="let stepItem of stepSchema; index as i">
                <li
                  *ngIf="isStepVisible(stepItem)"
                  class="step-item-wrapper"
                  [class.is-current]="isCurrentStep(i)"
                  [class.is-prev]="isGotoAllowed(i)"
                  [class.is-next]="isNextStep(i) && isCreatePage"
                >
                  <div
                    class="step-item"
                    (click)="isGotoAllowed(i) && gotoStep(i)"
                    [class.cursor-pointer]="isGotoAllowed(i)"
                  >
                    <div class="step-bullet">
                      <div class="step-bullet-icon">
                        <svg
                          width="8"
                          height="6"
                          viewBox="0 0 8 6"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 3L3.5 5L7 1"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <span>{{ stepItem.name | translate }}</span>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
          <div class="progress-indicator">
            <div
              class="current-progress"
              [ngStyle]="{
                width: stepPercentage + '%'
              }"
            ></div>
          </div>
          <div class="content-body-container" [class.new-editor-mode]="selectedEditorType === 'html' && currentStep === 3 && htmlTemplateSelected">
            <div class="content-side-nav" *ngIf="isStepSitenavAvailable">
              <ng-container *ngFor="let sideNav of stepSiteNavs; index as i">
                <div
                  class="side-nav-item"
                  [class.selected]="+subpage === +i"
                  [class.disabled]="sideNav.disabled"
                >
                  <div class="side-nav-item-inner" (click)="gotoSubpage(i)">
                    <div class="side-nav-icon-container">
                      <img
                        class="side-nav-icon"
                        [src]="convertToDataURI(sideNav.iconSVG)"
                      />
                    </div>
                    <div class="side-nav-title">
                      {{ sideNav.label | translate }}
                    </div>
                    <div
                      class="side-nav-soon"
                      *ngIf="sideNav.isComingSoon === true"
                    >
                      ({{ "Coming Soon" | translate }})
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="content-body">
              <div
                class="content-body-info"
                *ngIf="
                  stepSchema[currentStep]?.hideTitle !== true &&
                  stepSiteNavs[subpage]?.hideTitle !== true &&
                  !(selectedEditorType === 'new' && currentStep === 3 && subpage === 1) &&
                  !(selectedEditorType === 'html' && currentStep === 3 && htmlTemplateSelected)
                "
              >
                <h2 *ngIf="stepSchema[currentStep]?.title">
                  {{ stepSchema[currentStep]?.title | translate }}
                </h2>
                <span class="sub" *ngIf="currentStepSubtext">{{
                  currentStepSubtext | translate
                }}</span>
              </div>

              <div class="content-body-content">
                <!-- <ng-container [ngSwitch]="currentStep"> -->
                <!-- Step 1 -->
                <div
                  class="lg:col-span-2"
                  [class.d-display]="currentStep === 0"
                  [class.d-none]="currentStep !== 0"
                >
                  <div
                    class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                  >
                    <div class="col-span-6 md:col-span-3">
                      <label for="page-title" class="font-medium required">{{
                        "Page Title" | translate
                      }}</label>
                      <div class="page-input-loading-wrap mt-1">
                        <input
                          type="text"
                          name="page-title"
                          id="page-title"
                          class="h-10 border rounded px-3 w-full bg-gray-50 block"
                          [(ngModel)]="customPageData.page_title"
                          (ngModelChange)="markAsChanged()"
                          [disabled]="changeCountryIsLoading"
                          autocomplete="off"
                        />
                        <mat-spinner
                          *ngIf="changeCountryIsLoading"
                          class="page-input-spinner"
                          [diameter]="18"
                        ></mat-spinner>
                      </div>
                    </div>

                    <!-- No URL for a home page: it answers on the storefront's
                         home address, and its slug is assigned on save. -->
                    <div class="col-span-6 md:col-span-3" *ngIf="!isHomePage">
                      <label for="page-url" class="font-medium required">{{
                        "Page URL" | translate
                      }}</label>
                      <div class="page-url-input-group page-input-loading-wrap">
                        <span class="page-url-input-prefix">{{ "Page Path /" | translate }}</span>
                        <input
                          type="text"
                          name="page-url"
                          id="page-url"
                          class="page-url-input"
                          [class.has-warning]="pageUrlSlugWarning"
                          (input)="filterNonUrlCharacters($event); markAsChanged()"
                          (keydown)="blockNonUrlCharacters($event)"
                          (keypress)="blockNonUrlCharacters($event)"
                          [value]="customPageData.page_url"
                          [disabled]="changeCountryIsLoading"
                          autocomplete="off"
                        />
                        <mat-spinner
                          *ngIf="changeCountryIsLoading"
                          class="page-input-spinner"
                          [diameter]="18"
                        ></mat-spinner>
                      </div>
                      <small class="page-url-warning" *ngIf="pageUrlSlugWarning">
                        {{ pageUrlSlugWarning | translate }}
                      </small>
                    </div>

                    <div class="h-10">
                      <!-- Spacing -->
                    </div>
                  </div>
                </div>

                <!-- Step 2 -->
                <div
                  [class.d-display]="currentStep === 1"
                  [class.d-none]="currentStep !== 1"
                  [class.is-loading]="changeCountryIsLoading"
                >
                  <div>
                    <h3>{{ "Country" | translate }}</h3>
                    <div class="h-2">
                      <!-- Spacing -->
                    </div>

                    <div ngbDropdown class="block w-60 mb-4">
                      <button
                        class="btn btn-dropdown-new w-100"
                        id="dropdownBasic2"
                        ngbDropdownToggle
                      >
                        <div class="dropdown-name-inner">
                          {{
                            filteredCountry !== ""
                              ? getCountryName(filteredCountry)
                              : ("Select Country" | translate)
                          }}
                        </div>
                      </button>
                      <div
                        ngbDropdownMenu
                        aria-labelledby="dropdownBasic2"
                        class="custom-dropdown w-full"
                      >
                        <ng-container *ngFor="let c of country">
                          <button
                            ngbDropdownItem
                            (click)="changeCountry(c.country_code)"
                          >
                            {{ c.country_name | translate }}
                          </button>
                        </ng-container>
                      </div>
                    </div>

                    <div class="h-2">
                      <!-- Spacing -->
                    </div>

                    <div
                      class="loading-spinner"
                      *ngIf="
                        changeCountryIsLoading && productSeries.length === 0
                      "
                    >
                      <mat-spinner
                        class="mx-auto mt-5"
                        [diameter]="50"
                      ></mat-spinner>
                    </div>
                    <div
                      [class.disabled]="generateMethod || !enableAIPageTemplate"
                      *ngIf="productSeries.length > 0"
                    >
                      <h3>{{ "Series" | translate }}</h3>
                      <div class="product-series-container">
                        <ul class="product-series">
                          <ng-container *ngFor="let item of productSeries">
                            <li
                              [matTooltip]="item.name"
                              class="product-series-item"
                              [class.selected]="
                                selectedSeries?.toUpperCase() ===
                                item.name?.toUpperCase()
                              "
                              [style.background-image]="
                                'url(' + item.image + ')'
                              "
                              (click)="onSelectSeries(item.name)"
                            ></li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngIf="
                      !generateMethod &&
                      selectedSeries &&
                      productSeries.length > 0
                    "
                  >
                    <div
                      [class.disabled]="generateMethod || !enableAIPageTemplate"
                    >
                      <h3>{{ "Product" | translate }}</h3>
                      <div class="product-name-container">
                        <ul class="product-names">
                          <ng-container
                            *ngFor="let item of productNamesInSeries"
                          >
                            <li
                              [matTooltip]="item.name"
                              class="product-name-item"
                              [class.selected]="
                                selectedProduct?.toUpperCase() ===
                                item.name?.toUpperCase()
                              "
                              (click)="onSelectProduct(item)"
                            >
                              <div
                                class="product-image"
                                [style.background-image]="
                                  'url(' + item.image + ')'
                                "
                              ></div>
                            </li>
                          </ng-container>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="h-5">
                    <!-- Spacing -->
                  </div>
                  <div class="generate-method" *ngIf="productSeries.length > 0">
                    <div class="flex flex-column">
                      <label [class.disabled]="!enableAIPageTemplate"
                        ><input
                          type="radio"
                          name="generate-method"
                          [disabled]="!enableAIPageTemplate"
                          [value]="0"
                          [(ngModel)]="generateMethod"
                          (change)="onGenerateMethodChange()"
                        />
                        <span *ngIf="filteredCountry !== 'TWTW'">{{
                          "AI" | translate
                        }}</span>
                        {{
                          "Automatically-Generated (Pro Version)" | translate
                        }}</label
                      >
                      <div
                        ngbDropdown
                        class="block w-60 mb-4"
                        *ngIf="!generateMethod"
                      >
                        <button
                          class="btn btn-dropdown-new w-100"
                          id="dropdownBasic2"
                          ngbDropdownToggle
                          [class.disabled]="generateMethod"
                        >
                          <div class="dropdown-name-inner">
                            {{ language_name | translate }}
                          </div>
                        </button>
                        <div
                          ngbDropdownMenu
                          aria-labelledby="dropdownBasic2"
                          class="custom-dropdown w-full"
                        >
                          <ng-container *ngFor="let language of languages">
                            <button
                              ngbDropdownItem
                              (click)="
                                onLanguageChange(
                                  language.language_code,
                                  language.language_name
                                )
                              "
                            >
                              {{ language.language_name | translate }}
                            </button>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                    <div>
                      <label
                        ><input
                          type="radio"
                          name="generate-method"
                          [value]="1"
                          [(ngModel)]="generateMethod"
                          (change)="onGenerateMethodChange(); resetSeries()"
                        />{{ "Customize myself" | translate }}</label
                      >
                    </div>
                  </div>
                </div>
                <!-- Step 3: Editor Selection. Shown in create mode and, for HTML pages,
                     in edit mode too — its tab lets you re-confirm the editor and (via the
                     HTML card → Continue) reopen the "Select a Template" picker. -->
                <div
                  *ngIf="!isEditPage || selectedEditorType === 'html'"
                  [class.d-display]="currentStep === 2"
                  [class.d-none]="currentStep !== 2"
                >
                  <div class="editor-selection-container">
                    <div class="editor-options">
                      <div
                        *ngIf="showStudioEditor"
                        class="editor-option"
                        [class.selected]="selectedEditorType === 'new'"
                        [class.disabled]="isEditPage"
                        (click)="!isEditPage && onSelectEditor('new')"
                      >
                        <div class="editor-option-icon">
                          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.2988 9.9574L18.1778 8.8364C17.9902 8.6489 17.8847 8.39453 17.8846 8.12926C17.8846 7.86399 17.9898 7.60954 18.1773 7.4219C18.3649 7.23426 18.6192 7.1288 18.8845 7.1287C19.1498 7.12861 19.4042 7.2339 19.5918 7.4214L22.4198 10.2504C22.6073 10.4379 22.7126 10.6922 22.7126 10.9574C22.7126 11.2226 22.6073 11.4769 22.4198 11.6644L19.5918 14.4924C19.4032 14.6746 19.1506 14.7754 18.8884 14.7731C18.6263 14.7708 18.3754 14.6656 18.19 14.4802C18.0046 14.2948 17.8995 14.044 17.8972 13.7818C17.8949 13.5196 17.9957 13.267 18.1778 13.0784L19.2988 11.9574H12.8138V18.4424L13.9348 17.3214C14.1235 17.1392 14.3761 17.0385 14.6383 17.0407C14.9004 17.043 15.1513 17.1482 15.3367 17.3336C15.5221 17.519 15.6272 17.7698 15.6295 18.032C15.6318 18.2942 15.531 18.5468 15.3488 18.7354L12.5208 21.5644C12.3333 21.7519 12.079 21.8572 11.8138 21.8572C11.5487 21.8572 11.2944 21.7519 11.1068 21.5644L8.27785 18.7354C8.09569 18.5468 7.9949 18.2942 7.99717 18.032C7.99945 17.7698 8.10462 17.519 8.29003 17.3336C8.47544 17.1482 8.72625 17.043 8.98845 17.0407C9.25064 17.0385 9.50325 17.1392 9.69185 17.3214L10.8138 18.4424V11.9574H4.32785L5.44985 13.0784C5.63201 13.267 5.7328 13.5196 5.73052 13.7818C5.72824 14.044 5.62308 14.2948 5.43767 14.4802C5.25226 14.6656 5.00145 14.7708 4.73925 14.7731C4.47705 14.7754 4.22445 14.6746 4.03585 14.4924L1.20685 11.6644C1.01938 11.4769 0.914062 11.2226 0.914062 10.9574C0.914062 10.6922 1.01938 10.4379 1.20685 10.2504L4.03585 7.4204C4.22362 7.2329 4.47819 7.12766 4.74356 7.12785C5.00892 7.12804 5.26334 7.23363 5.45085 7.4214C5.63836 7.60918 5.74359 7.86375 5.7434 8.12911C5.74322 8.39447 5.63762 8.6489 5.44985 8.8364L4.32785 9.9564H10.8138V3.4734L9.69185 4.5934C9.50325 4.77556 9.25064 4.87636 8.98845 4.87408C8.72625 4.8718 8.47544 4.76663 8.29003 4.58122C8.10462 4.39581 7.99945 4.145 7.99717 3.8828C7.9949 3.62061 8.09569 3.36801 8.27785 3.1794L11.1068 0.350404C11.2944 0.162933 11.5487 0.0576172 11.8138 0.0576172C12.079 0.0576172 12.3333 0.162933 12.5208 0.350404L15.3488 3.1794C15.4444 3.27165 15.5205 3.382 15.573 3.504C15.6254 3.626 15.6529 3.75722 15.6541 3.89C15.6553 4.02278 15.63 4.15446 15.5797 4.27736C15.5294 4.40025 15.4551 4.51191 15.3612 4.6058C15.2674 4.69969 15.1557 4.77394 15.0328 4.82423C14.9099 4.87451 14.7782 4.89981 14.6454 4.89865C14.5127 4.8975 14.3814 4.86991 14.2594 4.8175C14.1374 4.7651 14.0271 4.68891 13.9348 4.5934L12.8138 3.4724V9.9574H19.2988Z" fill="currentColor"/>
                          </svg>
                        </div>
                        <h3>{{ "Studio Editor" | translate }}</h3>
                        <p>{{ "Advanced visual editor with more design flexibility." | translate }}</p>
                      </div>
                      <div
                        class="editor-option"
                        [class.selected]="selectedEditorType === 'html'"
                        (click)="onSelectEditor('html')"
                      >
                        <div class="editor-option-icon">
                          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 8L3 12L7 16M17 8L21 12L17 16M14 4L10 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                        <h3>{{ "HTML Editor" | translate }}</h3>
                        <p>{{ "Write your page directly in HTML for full control over the markup and styling." | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Step 4: Design page -->
                <div
                  class="relative"
                  [class.d-display]="currentStep === 3"
                  [class.d-none]="currentStep !== 3"
                >
                  <div
                    class="loading-overlay"
                    style="position: relative; min-height: 300px;"
                    *ngIf="customPageIsLoading && selectedEditorType === 'new' && currentStep === 3 && subpage === 1"
                  >
                    <div class="loading-dialog">
                      <div class="loading-body">
                        <h2>{{ progressValue }}%</h2>
                        <div>{{ "Loading content..." | translate }}</div>
                        <div
                          class="loading-progress"
                          [style.width]="progressValue + '%'"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <ng-container *ngIf="true || subpage === 0">
                    <!-- New Editor: Template selection at subpage 0 -->
                    <div
                      *ngIf="selectedEditorType === 'new' && currentStep === 3 && subpage === 0"
                      class="studio-template-selection"
                    >
                      <!-- Theme filter — options derive from the categories the
                           templates carry. .template-filter is what scopes the
                           dropdown's styles; clearfix contains its right float. -->
                      <div
                        class="template-filter clearfix"
                        *ngIf="studioDropdownCategoryList.length > 1"
                      >
                        <div ngbDropdown class="filter-dropdown-wrapper">
                          <div
                            ngbDropdownToggle
                            class="btn-template-filter-dropdown"
                          >
                            <div style="margin-right: 5px">
                              {{ "Theme :" | translate }}
                            </div>
                            <div style="color: #ebebeb; font-size: 15px">|</div>
                            <div style="margin-left: 5px">
                              {{ studioPageFilter | translate }}
                            </div>
                            <div style="margin-left: 10px">
                              <svg
                                width="9"
                                height="6"
                                viewBox="0 0 9 6"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M1.0003 0.666483C0.868471 0.666511 0.739606 0.705625 0.63 0.778881C0.520393 0.852138 0.434966 0.956247 0.38452 1.07805C0.334073 1.19985 0.320871 1.33387 0.346583 1.46317C0.372294 1.59247 0.435765 1.71125 0.528971 1.80448L3.8623 5.13782C3.98732 5.2628 4.15686 5.33301 4.33364 5.33301C4.51041 5.33301 4.67995 5.2628 4.80497 5.13782L8.1383 1.80448C8.23151 1.71125 8.29498 1.59247 8.32069 1.46317C8.34641 1.33387 8.3332 1.19985 8.28276 1.07805C8.23231 0.956247 8.14688 0.852139 8.03728 0.778882C7.92767 0.705626 7.79881 0.666511 7.66697 0.666483L1.0003 0.666483Z"
                                  fill="#818992"
                                />
                              </svg>
                            </div>
                          </div>
                          <div ngbDropdownMenu class="custom-dropdown">
                            <button
                              ngbDropdownItem
                              *ngFor="let categories of studioDropdownCategoryList"
                              [value]="categories.id"
                              (click)="onSelectStudioPage(categories.name)"
                            >
                              {{ categories.name | translate }}
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="page-theme-list custom-scrollbar">
                        <!-- Migrated Studio starter templates (status=2, e.g. Affiliate Buddy) -->
                        <div
                          *ngFor="let studioTheme of displayedStudioTemplateList"
                          class="page-theme-list-item"
                          [class.selected]="selectedStudioTemplate === studioTheme.store_page_theme_id"
                          (click)="onSelectStudioTheme(studioTheme)"
                          style="cursor: pointer;"
                        >
                          <div class="page-theme-name">
                            {{ studioTheme.theme_name }}
                          </div>
                          <div class="page-theme-preview">
                            <div
                              class="page-theme-preview-img"
                              [ngStyle]="{
                                'background-image': 'url(' + (studioTheme.theme_preview || 'assets/no-image.webp') + ')',
                                'background-size': 'cover',
                                'background-position': 'top center'
                              }"
                            ></div>
                          </div>
                          <div class="flex rating-container product-page-rating">
                            <span>&#9733;&#9733;&#9733;&#9733;&#9733;</span>
                          </div>
                          <div class="page-theme-action">
                            <button
                              class="btn btn-info btn-sm btn-select-theme"
                              (click)="onSelectStudioTheme(studioTheme); $event.stopPropagation()"
                            >
                              <i
                                class="fi fi-rr-check mr-2 align-middle"
                                *ngIf="selectedStudioTemplate === studioTheme.store_page_theme_id"
                              ></i>
                              <span>{{ "Use" | translate }}</span>
                            </button>
                          </div>
                        </div>
                        <!-- Product Page template -->
                        <div
                          *ngIf="generateMethod !== 1"
                          class="page-theme-list-item"
                          [class.selected]="selectedStudioTemplate === 'product'"
                          (click)="onSelectStudioTemplate('product')"
                          style="cursor: pointer;"
                        >
                          <div class="page-theme-name">
                            {{ "Product Page" | translate }}
                          </div>
                          <div class="page-theme-preview">
                            <div
                              class="page-theme-preview-img"
                              style="background-image: url('assets/product_page.webp'); background-size: cover; background-position: top center;"
                            ></div>
                          </div>
                          <div class="flex rating-container product-page-rating">
                            <span>&#9733;&#9733;&#9733;&#9733;&#9733;</span>
                          </div>
                          <div class="page-theme-action">
                            <button
                              class="btn btn-info btn-sm btn-select-theme"
                              (click)="onSelectStudioTemplate('product'); $event.stopPropagation()"
                            >
                              <i
                                class="fi fi-rr-check mr-2 align-middle"
                                *ngIf="selectedStudioTemplate === 'product'"
                              ></i>
                              <span>{{ "Use" | translate }}</span>
                            </button>
                          </div>
                        </div>
                        <!-- Blank template -->
                        <div
                          *ngIf="!isEditPage && generateMethod === 1"
                          class="page-theme-list-item"
                          [class.selected]="selectedStudioTemplate === 'blank'"
                          (click)="onSelectStudioTemplate('blank')"
                          style="cursor: pointer;"
                        >
                          <div class="page-theme-name">
                            {{ "Blank" | translate }}
                          </div>
                          <div class="page-theme-preview">
                            <div class="blank-theme-preview">
                              <div><i class="fi fi-rr-file"></i></div>
                            </div>
                          </div>
                          <div class="page-theme-action">
                            <button
                              class="btn btn-info btn-sm btn-select-theme"
                              (click)="onSelectStudioTemplate('blank'); $event.stopPropagation()"
                            >
                              <i
                                class="fi fi-rr-check mr-2 align-middle"
                                *ngIf="selectedStudioTemplate === 'blank'"
                              ></i>
                              <span>{{ "Use" | translate }}</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- New Editor: Show iframe when New Editor is selected (content subpage) -->
                    <div
                      *ngIf="selectedEditorType === 'new' && studioTemplateSelected"
                      [class.d-none]="currentStep !== 3 || subpage !== 1 || customPageIsLoading"
                      class="new-editor-wrapper"
                      [class.full-page]="fullPageMode"
                    >
                      <div
                        class="new-editor-controls bg-white rounded-md p-2 px-4 md:p-2 mb-2 d-flex align-items-center"
                        [class.full-page-controls]="fullPageMode"
                      >
                        <!-- A converted classic page, until its first save: one line
                             here, the details on hover or keyboard focus -->
                        <button
                          *ngIf="isClassicUpgrade && classicUpgradeReport"
                          type="button"
                          class="classic-upgrade-chip"
                          [ngbPopover]="classicUpgradeDetails"
                          triggers="mouseenter:mouseleave focusin:focusout"
                          placement="bottom-left"
                          container="body"
                          popoverClass="classic-upgrade-popover"
                        >
                          <i class="fi fi-rr-info" aria-hidden="true"></i>
                          <span>{{ "Converted from the Classic editor" | translate }}</span>
                          <span class="classic-upgrade-chip__hint">· {{ "Save to apply" | translate }}</span>
                        </button>
                        <ng-template #classicUpgradeDetails>
                          <div class="classic-upgrade-details">
                            <div class="font-weight-bold mb-1">
                              {{ "This page was made in the Classic editor and has been converted for the Studio editor." | translate }}
                            </div>
                            <div class="mb-1">
                              {{ "Review it, then save. Your live page stays as it is until you save." | translate }}
                            </div>
                            <div>
                              {{
                                "{0} sections can be edited field by field. {1} are kept as HTML blocks: edit their HTML to change them."
                                  | translate
                                    : [
                                        classicUpgradeReport.editableCount,
                                        classicUpgradeReport.htmlBlockCount
                                      ]
                              }}
                            </div>
                            <ul
                              *ngIf="classicUpgradeReport.warnings.length"
                              class="mb-0 mt-2 pl-3"
                            >
                              <li *ngFor="let warning of classicUpgradeReport.warnings">
                                {{ classicUpgradeWarningText[warning] | translate }}
                              </li>
                            </ul>
                          </div>
                        </ng-template>
                        <button
                          class="btn btn-outline-success ml-auto"
                          (click)="toggleFullPageMode()"
                        >
                          <i
                            *ngIf="!fullPageMode"
                            class="fi fi-rr-expand mr-2"
                          ></i>
                          <i
                            *ngIf="fullPageMode"
                            class="fi fi-rr-compress mr-2"
                          ></i>
                          {{
                            (fullPageMode
                              ? "Exit fullpage mode"
                              : "Enter fullpage mode"
                            ) | translate
                          }}
                        </button>
                      </div>
                      <div
                        class="new-editor-iframe-container"
                        [class.full-page]="fullPageMode"
                      >
                        <iframe
                          #newEditorIframe
                          [src]="getNewEditorUrl()"
                          (load)="onIframeLoad()"
                          frameborder="0"
                          class="new-editor-iframe"
                          allowfullscreen
                        ></iframe>
                      </div>
                    </div>
                    <!-- HTML Editor: Template selection (shown before the code editor) -->
                    <div
                      *ngIf="selectedEditorType === 'html' && currentStep === 3 && !htmlTemplateSelected"
                      class="html-template-selection"
                    >
                      <!-- Product flow: the chosen template's HTML is generated by the
                           AI (~15s). The card list is removed from the DOM (not just
                           dimmed) for the duration — it is far taller than the
                           viewport, so an overlay on top of it left the lower half of
                           the page blank and the progress dialog stranded offscreen.
                           Standing alone, the progress panel is the whole step. -->
                      <div
                        class="html-template-generating"
                        *ngIf="isGeneratingProductHtml"
                      >
                        <div class="loading-body">
                          <h2>{{ progressValue }}%</h2>
                          <div>
                            {{ "Generating your page content with AI..." | translate }}
                          </div>
                          <div class="loading-progress-track">
                            <div
                              class="loading-progress"
                              [style.width]="progressValue + '%'"
                            ></div>
                          </div>
                          <div class="loading-hint">
                            {{ "This usually takes about 15 seconds. Please don't close this page." | translate }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="page-theme-list custom-scrollbar"
                        *ngIf="!isGeneratingProductHtml"
                      >
                        <div
                          *ngIf="isLoadingHtmlTemplates"
                          style="
                            width: 100%;
                            padding: 32px;
                            text-align: center;
                            opacity: 0.7;
                          "
                        >
                          {{ "Loading templates..." | translate }}
                        </div>
                        <div
                          *ngIf="
                            !isLoadingHtmlTemplates && !htmlTemplates.length
                          "
                          style="
                            width: 100%;
                            padding: 32px;
                            text-align: center;
                            opacity: 0.7;
                          "
                        >
                          {{ "No templates available." | translate }}
                        </div>
                        <!-- Edit mode fallback: shown only when the page has no template
                             marker (legacy pages). When the source template IS known it
                             is pre-selected and highlighted in the list below instead, so
                             this card is hidden. Continuing with it keeps existing content. -->
                        <div
                          *ngIf="isEditPage && !selectedHtmlTemplate"
                          class="page-theme-list-item html-template-item"
                          [class.selected]="!selectedHtmlTemplate"
                          (click)="onKeepCurrentHtmlPage()"
                          style="cursor: pointer"
                        >
                          <div class="page-theme-name">
                            {{ "Current page" | translate }}
                          </div>
                          <div class="page-theme-preview">
                            <div class="blank-theme-preview">
                              <div><i class="fi fi-rr-edit"></i></div>
                            </div>
                          </div>
                          <p class="html-template-desc">
                            {{
                              "Keep this page's existing content. Pick a template below only to start over."
                                | translate
                            }}
                          </p>
                          <div class="page-theme-action">
                            <button
                              class="btn btn-info btn-sm btn-select-theme"
                              (click)="
                                onKeepCurrentHtmlPage();
                                $event.stopPropagation()
                              "
                            >
                              <i
                                class="fi fi-rr-check mr-2 align-middle"
                                *ngIf="!selectedHtmlTemplate"
                              ></i>
                              <span>{{ "Keep" | translate }}</span>
                            </button>
                          </div>
                        </div>
                        <!-- Grouped templates first: one card per group, its
                             variants swappable from the editor's Styles dropdown.
                             Section headers are hidden while the list is empty or
                             loading (the states above cover that). -->
                        <ng-container *ngIf="multiStyleHtmlTemplates.length">
                          <button
                            type="button"
                            class="html-template-section-heading"
                            [class.collapsed]="
                              htmlTemplateSectionCollapsed.multi
                            "
                            [attr.aria-expanded]="
                              !htmlTemplateSectionCollapsed.multi
                            "
                            (click)="toggleHtmlTemplateSection('multi')"
                          >
                            <i
                              class="html-template-section-caret fi"
                              [ngClass]="
                                htmlTemplateSectionCollapsed.multi
                                  ? 'fi-rr-angle-small-right'
                                  : 'fi-rr-angle-small-down'
                              "
                            ></i>
                            <span class="html-template-section-title">
                              {{ "Multi-Style Templates" | translate }}
                            </span>
                            <span class="html-template-section-count">
                              {{ multiStyleHtmlTemplates.length }}
                            </span>
                            <span class="html-template-section-hint">
                              {{
                                "Switch between style variants while editing."
                                  | translate
                              }}
                            </span>
                          </button>
                          <ng-container
                            *ngIf="!htmlTemplateSectionCollapsed.multi"
                          >
                            <ng-container
                              *ngFor="let tpl of multiStyleHtmlTemplates"
                            >
                              <ng-container
                                *ngTemplateOutlet="
                                  htmlTemplateCard;
                                  context: { tpl: tpl }
                                "
                              ></ng-container>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="singleStyleHtmlTemplates.length">
                          <button
                            type="button"
                            class="html-template-section-heading"
                            [class.collapsed]="
                              htmlTemplateSectionCollapsed.single
                            "
                            [attr.aria-expanded]="
                              !htmlTemplateSectionCollapsed.single
                            "
                            (click)="toggleHtmlTemplateSection('single')"
                          >
                            <i
                              class="html-template-section-caret fi"
                              [ngClass]="
                                htmlTemplateSectionCollapsed.single
                                  ? 'fi-rr-angle-small-right'
                                  : 'fi-rr-angle-small-down'
                              "
                            ></i>
                            <span class="html-template-section-title">
                              {{ "Single-Style Templates" | translate }}
                            </span>
                            <span class="html-template-section-count">
                              {{ singleStyleHtmlTemplates.length }}
                            </span>
                          </button>
                          <ng-container
                            *ngIf="!htmlTemplateSectionCollapsed.single"
                          >
                            <ng-container
                              *ngFor="let tpl of singleStyleHtmlTemplates"
                            >
                              <ng-container
                                *ngTemplateOutlet="
                                  htmlTemplateCard;
                                  context: { tpl: tpl }
                                "
                              ></ng-container>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      </div>
                    </div>
                    <!-- One picker card, rendered once per section above. -->
                    <ng-template #htmlTemplateCard let-tpl="tpl">
                      <div
                        class="page-theme-list-item html-template-item"
                        [class.selected]="selectedHtmlTemplate === tpl.id"
                        (click)="onSelectHtmlTemplate(tpl.id)"
                        style="cursor: pointer"
                      >
                        <div class="page-theme-name">
                          {{ tpl.name | translate }}
                          <span
                            *ngIf="tpl.group?.styles?.length > 1"
                            class="html-template-group-badge"
                          >
                            {{ tpl.group.styles.length }}
                            {{ "styles" | translate }}
                          </span>
                        </div>
                        <div class="page-theme-preview">
                          <div *ngIf="tpl.isBlank" class="blank-theme-preview">
                            <div><i class="fi fi-rr-file"></i></div>
                          </div>
                          <div
                            *ngIf="!tpl.isBlank"
                            class="html-template-thumb"
                            [attr.data-template]="tpl.id"
                          >
                            <i [ngClass]="tpl.icon || 'fi fi-rr-file'"></i>
                            <span>{{ tpl.name | translate }}</span>
                          </div>
                        </div>
                        <p class="html-template-desc">
                          {{ tpl.description | translate }}
                        </p>
                        <div
                          class="html-template-tags"
                          *ngIf="tpl.fallsUnder?.length"
                        >
                          <span
                            class="html-template-tag"
                            *ngFor="let tag of tpl.fallsUnder"
                            >{{ tag }}</span
                          >
                        </div>
                        <div class="page-theme-action">
                          <button
                            class="btn btn-info btn-sm btn-select-theme"
                            (click)="
                              onSelectHtmlTemplate(tpl.id);
                              $event.stopPropagation()
                            "
                          >
                            <i
                              class="fi fi-rr-check mr-2 align-middle"
                              *ngIf="selectedHtmlTemplate === tpl.id"
                            ></i>
                            <span>{{ "Use" | translate }}</span>
                          </button>
                        </div>
                      </div>
                    </ng-template>
                    <!-- HTML Editor: Show code editor with preview -->
                    <div
                      *ngIf="selectedEditorType === 'html' && currentStep === 3 && htmlTemplateSelected"
                      class="html-editor-wrapper"
                      [class.full-page-editor]="htmlPreviewFullscreen"
                    >
                      <!-- Toolbar -->
                      <div class="html-editor-toolbar flex items-center justify-between px-3 py-2 bg-gray-50 border-b border-gray-200">
                        <div class="html-editor-toolbar-left flex items-center space-x-2">
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="text-indigo-600">
                            <path d="M7 8L3 12L7 16M17 8L21 12L17 16M14 4L10 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          <span class="font-semibold text-gray-800 text-sm">{{ "HTML Editor" | translate }}</span>
                          <span *ngIf="htmlPreviewFullscreen" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold bg-indigo-100 text-indigo-800 ml-2 hidden sm:inline-flex">
                            <i class="fi fi-rr-expand mr-1"></i> {{ "FULLSCREEN" | translate }}
                          </span>
                        </div>
                        <div class="html-editor-toolbar-right flex items-center space-x-2 flex-wrap">
                          <!-- View Mode Toggle -->
                          <div class="html-toolbar-toggle-group flex items-center bg-gray-200 p-0.5 rounded-lg">
                            <button
                              type="button"
                              class="html-toolbar-toggle px-2.5 py-1 text-xs font-medium rounded-md transition-all"
                              [class.active]="htmlEditorViewMode === 'code'"
                              (click)="setHtmlEditorViewMode('code')"
                              ngbTooltip="{{ 'Code only' | translate }}"
                              placement="bottom"
                            >
                              <i class="fi fi-rr-comment-code mr-1"></i>
                              <span class="hidden md:inline">{{ "Code" | translate }}</span>
                            </button>
                            <button
                              type="button"
                              class="html-toolbar-toggle px-2.5 py-1 text-xs font-medium rounded-md transition-all"
                              [class.active]="htmlEditorViewMode === 'split'"
                              (click)="setHtmlEditorViewMode('split')"
                              ngbTooltip="{{ 'Split view' | translate }}"
                              placement="bottom"
                            >
                              <i class="fi fi-rr-browser mr-1"></i>
                              <span class="hidden md:inline">{{ "Split" | translate }}</span>
                            </button>
                            <button
                              type="button"
                              class="html-toolbar-toggle px-2.5 py-1 text-xs font-medium rounded-md transition-all"
                              [class.active]="htmlEditorViewMode === 'preview'"
                              (click)="setHtmlEditorViewMode('preview')"
                              ngbTooltip="{{ 'Preview only' | translate }}"
                              placement="bottom"
                            >
                              <i class="fi fi-rr-eye mr-1"></i>
                              <span class="hidden md:inline">{{ "Preview" | translate }}</span>
                            </button>
                          </div>

                          <!-- Device Viewport Toggle (Desktop, Tablet, Mobile) -->
                          <div
                            *ngIf="htmlEditorViewMode !== 'code'"
                            class="html-toolbar-toggle-group flex items-center bg-gray-200 p-0.5 rounded-lg ml-1"
                          >
                            <button
                              type="button"
                              class="html-toolbar-toggle px-2 py-1 text-xs font-medium rounded-md transition-all"
                              [class.active]="previewDeviceMode === 'desktop'"
                              (click)="setPreviewDeviceMode('desktop')"
                              ngbTooltip="{{ 'Desktop view (100%)' | translate }}"
                              placement="bottom"
                            >
                              <i class="fi fi-rr-computer"></i>
                            </button>
                            <button
                              type="button"
                              class="html-toolbar-toggle px-2 py-1 text-xs font-medium rounded-md transition-all"
                              [class.active]="previewDeviceMode === 'tablet'"
                              (click)="setPreviewDeviceMode('tablet')"
                              ngbTooltip="{{ 'Tablet view (768px)' | translate }}"
                              placement="bottom"
                            >
                              <i class="fi fi-rr-tablet"></i>
                            </button>
                            <button
                              type="button"
                              class="html-toolbar-toggle px-2 py-1 text-xs font-medium rounded-md transition-all"
                              [class.active]="previewDeviceMode === 'mobile'"
                              (click)="setPreviewDeviceMode('mobile')"
                              ngbTooltip="{{ 'Mobile view (375px)' | translate }}"
                              placement="bottom"
                            >
                              <i class="fi fi-rr-mobile"></i>
                            </button>
                          </div>

                          <!-- Fullscreen Button -->
                          <button
                            type="button"
                            class="html-toolbar-btn px-2.5 py-1 text-xs font-medium rounded-md border transition-all"
                            [class.active]="htmlPreviewFullscreen"
                            (click)="toggleHtmlPreviewFullscreen()"
                            ngbTooltip="{{ (htmlPreviewFullscreen ? 'Exit fullpage mode' : 'Fullscreen') | translate }}"
                            placement="bottom"
                          >
                            <i [class]="htmlPreviewFullscreen ? 'fi fi-rr-compress mr-1' : 'fi fi-rr-expand mr-1'"></i>
                            <span class="hidden sm:inline">{{ (htmlPreviewFullscreen ? "Exit Fullscreen" : "Fullscreen") | translate }}</span>
                          </button>

                          <!-- Save Button (Full Screen View Only) -->
                          <button
                            *ngIf="htmlPreviewFullscreen"
                            type="button"
                            class="fullscreen-save-btn btn btn-sm bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 py-1.5 rounded-lg flex items-center shadow-md hover:shadow-emerald-600/30 transition active:scale-95 border-none ml-1.5"
                            [disabled]="customPageIsSaving"
                            (click)="updateCustomPage($event, SAVE_BEHAVIOUR.SAVE)"
                            ngbTooltip="{{ 'Save page changes' | translate }}"
                            placement="bottom"
                          >
                            <i [class]="customPageIsSaving ? 'fi fi-rr-spinner animate-spin mr-1.5' : 'fi fi-rr-disk mr-1.5'"></i>
                            <span>{{ (customPageIsSaving ? "Saving..." : "Save Changes") | translate }}</span>
                          </button>

                          <div class="html-toolbar-divider hidden sm:block h-4 w-px bg-gray-300 mx-1"></div>

                          <!-- Styles: the variants of the chosen template's group -->
                          <div
                            class="html-toolbar-styles flex items-center space-x-1"
                            *ngIf="activeTemplateStyles.length > 1"
                          >
                            <label
                              class="html-toolbar-styles-label text-xs font-medium text-gray-600"
                              for="html-style-select"
                            >
                              {{ "Styles" | translate }}
                            </label>
                            <select
                              id="html-style-select"
                              class="html-toolbar-styles-select text-xs border border-gray-300 rounded px-2 py-1 bg-white"
                              [ngModel]="activeStyleId"
                              (ngModelChange)="onSelectStyle($event)"
                              [disabled]="isLoadingSelectedTheme || isGeneratingProductHtml"
                              ngbTooltip="{{ 'Switch to another style of this template' | translate }}"
                              placement="bottom"
                            >
                              <option
                                *ngFor="let style of activeTemplateStyles"
                                [ngValue]="style.id"
                                [disabled]="
                                  activeStyleId !== null &&
                                  style.id.toString() === activeStyleId.toString()
                                "
                              >
                                {{ style.name }}
                              </option>
                            </select>
                          </div>
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary text-xs px-2.5 py-1 rounded flex items-center"
                            (click)="updateHtmlPreview(true)"
                            ngbTooltip="{{ 'Refresh preview frame' | translate }}"
                            placement="bottom"
                          >
                            <i class="fi fi-rr-refresh mr-1"></i>
                            <span class="hidden lg:inline">{{ "Refresh" | translate }}</span>
                          </button>
                        </div>
                      </div>
                      <!-- Split Panes -->
                      <div class="html-editor-split">
                        <!-- Code Pane -->
                        <div class="html-editor-code-pane" [class.d-none]="htmlEditorViewMode === 'preview'">
                          <div class="html-editor-pane-header">
                            <span>{{ "Code" | translate }}</span>
                            <div class="html-editor-pane-actions">
                              <button
                                class="html-editor-action-btn"
                                (click)="openHtmlEditorSearch()"
                                ngbTooltip="{{ 'Find & Replace (Ctrl+F)' | translate }}"
                                placement="bottom"
                              >
                                <i class="fi fi-rr-search mr-1"></i>
                                {{ "Find" | translate }}
                              </button>
                              <button
                                class="html-editor-action-btn"
                                (click)="copyHtmlContent()"
                                ngbTooltip="{{ 'Copy to clipboard' | translate }}"
                                placement="bottom"
                              >
                                <i class="fi fi-rr-copy mr-1"></i>
                                {{ "Copy" | translate }}
                              </button>
                              <button
                                class="html-editor-clear-btn"
                                (click)="clearHtmlEditor()"
                                ngbTooltip="{{ 'Clear all code' | translate }}"
                                placement="bottom"
                              >
                                <i class="fi fi-rr-trash mr-1"></i>
                                {{ "Clear" | translate }}
                              </button>
                            </div>
                          </div>
                          <div id="html-code-editor" class="html-code-editor-container"></div>
                          <div class="html-editor-statusbar">
                            <span>{{ "Ln" | translate }} {{ htmlEditorCursorLine }}, {{ "Col" | translate }} {{ htmlEditorCursorCol }}</span>
                            <span>{{ htmlEditorLineCount }} {{ "lines" | translate }}</span>
                            <span>{{ htmlEditorCharCount }} {{ "chars" | translate }}</span>
                          </div>
                        </div>
                        <!-- Preview Pane -->
                        <div
                          class="html-editor-preview-pane"
                          [class.d-none]="htmlEditorViewMode === 'code'"
                        >
                          <div class="html-editor-pane-header">
                            <span>{{ "Preview" | translate }}</span>
                          </div>
                          <div
                            class="html-preview-area"
                            [class.device-desktop]="previewDeviceMode === 'desktop'"
                            [class.device-tablet]="previewDeviceMode === 'tablet'"
                            [class.device-mobile]="previewDeviceMode === 'mobile'"
                          >
                            <iframe id="html-preview-frame" class="html-preview-iframe"></iframe>
                            <!-- Empty State -->
                            <div class="html-preview-empty" *ngIf="!htmlEditorContent">
                              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 8L3 12L7 16M17 8L21 12L17 16M14 4L10 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                              <p>{{ "Start typing HTML to see a live preview" | translate }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <!-- Step 5: Settings -->

                <div
                  [class.d-display]="currentStep === 4"
                  [class.d-none]="currentStep !== 4"
                >
                  <div class="setting-page">
                    <div
                      class="mb-10 flex flex-column items-center justify-center"
                    >
                      <div class="container mx-auto">
                        <h2 class="section-label">
                          {{ "Page appearance" | translate }}
                        </h2>
                      </div>
                      <div class="container mx-auto">
                        <div>
                          <div class="setting-container">
                            <!-- <div
                              class="setting-group grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3 pb-3"
                            >
                              <div class="text-gray-600">
                                <p class="section-group-title">
                                  {{ "Page Layout" | translate }}
                                </p>
                                <p class="mb-3">
                                  {{
                                    "By turning off this option, your page will not be visible in the storefront."
                                      | translate
                                  }}
                                </p>
                              </div>

                              <div class="lg:col-span-2 gap-3 grid">
                                <div
                                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                                >
                                  <div class="md:col-span-5">
                                    <div class="mb-2">
                                      <span
                                        for="page-visibility"
                                        class="section-group"
                                        >{{
                                          "Header & Footer Visibility"
                                            | translate
                                        }}</span
                                      >
                                    </div>
                                    <div class="flex items-center mb-2">
                                      <label>
                                        <div>
                                          <input
                                            type="checkbox"
                                            name="page-header"
                                            id="page-header"
                                            [value]="false"
                                            class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            [(ngModel)]="
                                              customPageData.page_option
                                                .show_header
                                            "
                                            (ngModelChange)="markAsChanged()"
                                          />
                                          <span>{{
                                            "Display Page Header" | translate
                                          }}</span>
                                        </div>
                                      </label>
                                    </div>
                                    <div class="flex items-center mb-2">
                                      <label>
                                        <div>
                                          <input
                                            type="checkbox"
                                            name="page-footer"
                                            id="page-footer"
                                            [value]="false"
                                            class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            [(ngModel)]="
                                              customPageData.page_option
                                                .show_footer
                                            "
                                            (ngModelChange)="markAsChanged()"
                                          />
                                          <span>{{
                                            "Display Page Footer" | translate
                                          }}</span>
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                                >
                                  <div class="md:col-span-5">
                                    <div class="mb-2">
                                      <span
                                        for="page-visibility"
                                        class="section-group-title"
                                        >{{
                                          "Container Behaviour" | translate
                                        }}</span
                                      >
                                    </div>
                                    <div class="flex items-center mb-2">
                                      <label>
                                        <div>
                                          <input
                                            type="radio"
                                            name="page-layout-fixed"
                                            id="page-layout-fixed"
                                            [value]="1"
                                            class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            [(ngModel)]="
                                              customPageData.page_option
                                                .container_style
                                            "
                                            (ngModelChange)="markAsChanged()"
                                          />
                                          <span>{{
                                            "Fixed width" | translate
                                          }}</span>
                                        </div>
                                      </label>
                                    </div>
                                    <div class="flex items-center mb-2">
                                      <label>
                                        <div>
                                          <input
                                            type="radio"
                                            name="page-layout-fluid"
                                            id="page-layout-fluid"
                                            [value]="2"
                                            class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            [(ngModel)]="
                                              customPageData.page_option
                                                .container_style
                                            "
                                          />
                                          <span>{{
                                            "Fluid width" | translate
                                          }}</span>
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                            <div
                              class="setting-group grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3 pt-3"
                            >
                              <div class="text-gray-600">
                                <p class="section-group-title">
                                  {{ "Custom Javascript" | translate }}
                                </p>
                                <p class="mb-3">
                                  {{
                                    "Paste your JavaScript code into this box to add custom functionality to your landing page. The &lt;script&gt; tag is required to include JavaScript code or reference external scripts. Your changes will be automatically applied to your page."
                                      | translate
                                  }}
                                </p>
                              </div>

                              <div class="lg:col-span-2">
                                <div
                                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                                >
                                  <div class="md:col-span-5">
                                    <label for="page-js" class="font-medium">{{
                                      "JS Code" | translate
                                    }}</label>
                                    <div
                                      #pageJsRef
                                      name="page-js"
                                      id="page-js"
                                      class="editor-element"
                                    ></div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <!-- <pre class="p-3">{{ customPageData | json }}</pre> -->
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mb-10 flex flex-column items-center justify-center"
                    >
                      <div class="container mx-auto">
                        <h2 class="section-label">
                          {{ "Visibility" | translate }}
                        </h2>
                      </div>
                      <div class="container mx-auto">
                        <div>
                          <div class="setting-container">
                            <div
                              class="setting-group grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3"
                            >
                              <div class="text-gray-600">
                                <p class="section-group-title">
                                  {{ "Visibility" | translate }}
                                </p>
                                <p class="mb-3">
                                  {{
                                    "By turning off this option, your page will not be visible in the storefront."
                                      | translate
                                  }}
                                </p>
                              </div>

                              <div class="lg:col-span-1">
                                <div
                                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                                >
                                  <div class="md:col-span-5">
                                    <div class="mb-2">
                                      <span
                                        for="page-visibility"
                                        class="font-medium"
                                        >{{ "Visiblility" | translate }}</span
                                      >
                                    </div>
                                    <div class="flex items-center mb-2">
                                      <label>
                                        <div>
                                          <input
                                            type="radio"
                                            name="page-visibility"
                                            id="page-visibility-yes"
                                            [value]="1"
                                            class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            [(ngModel)]="
                                              customPageData.visibility
                                            "
                                          />
                                          <span>{{
                                            "Public" | translate
                                          }}</span>
                                        </div>
                                      </label>
                                    </div>
                                    <div class="flex items-center mb-2">
                                      <label>
                                        <div>
                                          <input
                                            type="radio"
                                            name="page-visibility"
                                            id="page-visibility-no"
                                            [value]="0"
                                            class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            [(ngModel)]="
                                              customPageData.visibility
                                            "
                                          />
                                          <span>{{
                                            "Private" | translate
                                          }}</span>
                                        </div>
                                      </label>
                                    </div>
                                    <div
                                      class="flex items-center mb-2"
                                      *ngIf="
                                        affiliateBuddyList !== undefined &&
                                        affiliateBuddyList.length > 0
                                      "
                                    >
                                      <label>
                                        <div>
                                          <input
                                            type="radio"
                                            name="page-visibility"
                                            id="page-visibility-ab"
                                            [value]="2"
                                            class="mr-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                                            [(ngModel)]="
                                              customPageData.visibility
                                            "
                                          />
                                          <span>{{
                                            "Affiliate Buddy" | translate
                                          }}</span>
                                        </div>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                class="text-gray-600"
                                *ngIf="customPageData.visibility === 2"
                              >
                                <p class="section-group-title">
                                  {{ "Select Affiliate Buddy" | translate }}
                                </p>
                                <div ngbDropdown class="block w-80 mb-4">
                                  <button
                                    class="btn btn-dropdown-new w-100"
                                    id="dropdownBasic2"
                                    ngbDropdownToggle
                                  >
                                    <div class="dropdown-name-inner">
                                      {{ getSelectedABOptionsText() }}
                                    </div>
                                  </button>
                                  <div
                                    ngbDropdownMenu
                                    aria-labelledby="dropdownBasic2"
                                    class="custom-dropdown w-full"
                                  >
                                    <ng-container
                                      *ngFor="let buddy of affiliateBuddyList"
                                    >
                                      <div
                                        ngbDropdownItem
                                        class="dropdown-item"
                                      >
                                        <label>
                                          <input
                                            type="checkbox"
                                            [checked]="
                                              isABSelected(buddy.dealer_id)
                                            "
                                            (change)="
                                              toggleABSelection(buddy.dealer_id)
                                            "
                                          />
                                          {{ buddy.fullname }} ({{
                                            buddy.dealer_id
                                          }})
                                        </label>
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mb-10 flex flex-column items-center justify-center"
                    >
                      <div class="container mx-auto">
                        <h2 class="section-label">
                          {{ "Page Metadata" | translate }}
                        </h2>
                      </div>
                      <div class="container mx-auto">
                        <div>
                          <div class="setting-container">
                            <div
                              class="setting-group grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3"
                            >
                              <div class="text-gray-600">
                                <p class="section-group-title">
                                  {{ "Metadata & SEO Information" | translate }}
                                </p>
                                <p class="mb-3">
                                  {{
                                    "Meta details, also known as search descriptions, are short pieces of text that describe your site's content."
                                      | translate
                                  }}
                                </p>
                                <p class="mb-3">
                                  {{
                                    "Search engines show meta descriptions below the page title in search results if they can't find site content that's more relevant to a visitor's search terms."
                                      | translate
                                  }}
                                </p>
                              </div>

                              <div class="lg:col-span-2">
                                <div
                                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                                >
                                  <div class="md:col-span-5">
                                    <label
                                      for="custom-page-title"
                                      class="font-medium"
                                      >{{ "Meta Title" | translate }}</label
                                    >
                                    <input
                                      type="text"
                                      name="custom-page-title"
                                      id="custom-page-title"
                                      class="h-10 border mt-1 rounded px-3 w-full setting-input-form"
                                      [(ngModel)]="
                                        customPageData.metadata.page_title
                                      "
                                      (ngModelChange)="markAsChanged()"
                                    />
                                  </div>
                                  <div class="md:col-span-5">
                                    <label
                                      for="meta-description"
                                      class="font-medium"
                                      >{{
                                        "Meta Description" | translate
                                      }}</label
                                    >
                                    <textarea
                                      name="meta-description"
                                      id="meta-description"
                                      class="border mt-1 rounded px-3 w-full h-28 setting-input-form py-2 resize-y"
                                      [(ngModel)]="
                                        customPageData.metadata.description
                                      "
                                      (ngModelChange)="markAsChanged()"
                                    ></textarea>
                                  </div>
                                  <div class="md:col-span-5">
                                    <label
                                      for="meta-keywords"
                                      class="font-medium"
                                      >{{ "Meta Keywords" | translate }}</label
                                    >
                                    <input
                                      type="text"
                                      name="meta-keywords"
                                      id="meta-keywords"
                                      class="h-10 border mt-1 rounded px-3 w-full setting-input-form"
                                      [(ngModel)]="
                                        customPageData.metadata.keywords
                                      "
                                      (ngModelChange)="markAsChanged()"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="mb-10 flex flex-column items-center justify-center"
                    >
                      <div class="container mx-auto">
                        <h2 class="section-label">
                          {{ "Site Identity" | translate }}
                        </h2>
                      </div>
                      <div class="container mx-auto">
                        <div>
                          <div class="setting-container">
                            <div
                              class="setting-group grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3"
                            >
                              <div class="text-gray-600">
                                <p class="section-group-title">
                                  {{ "What's OG:Image?" | translate }}
                                </p>
                                <p class="mb-3 mr-5">
                                  {{
                                    "An OG (Open Graph) image, on the other hand, is a larger image that is used by social media platforms like Facebook, WhatsApp, Twitter, and LinkedIn to display a preview of a website when it's shared on those platforms."
                                      | translate
                                  }}
                                  <br />
                                  <br />
                                  {{
                                    "The OG image is usually a higher quality image, typically at least 1200x630 pixels in size, and is designed to grab users' attention and make them want to click through to the website."
                                      | translate
                                  }}
                                </p>
                              </div>

                              <div class="lg:col-span-2">
                                <div
                                  class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                                >
                                  <div class="md:col-span-5">
                                    <label
                                      for="custom-page-title"
                                      class="font-medium"
                                      >{{
                                        "Link Preview (Open Graph - Image)"
                                          | translate
                                      }}</label
                                    >
                                    <div class="img-media">
                                      <media-selector
                                        [(imgURL)]="ogimgURL"
                                        [(mediaID)]="ogImgPhotoId"
                                        [minWidth]="OG_IMAGE_MIN_WIDTH"
                                        [minHeight]="OG_IMAGE_MIN_HEIGHT"
                                        [maxBytes]="OG_IMAGE_MAX_BYTES"
                                        (mediaChanged)="ogImgChanged($event)"
                                      ></media-selector>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Step Default -->
                <!-- <div class="text-muted center" *ngSwitchDefault>
                  {{ "Step content not available." | translate }}
                </div> -->
                <!-- </ng-container> -->
              </div>
            </div>
          </div>
          <div class="content-footer">
            <!-- Remove store modal -->
            <ng-template #returnConfirmModal let-modal>
              <div class="modal-body mt-3">
                <div class="text-subtitle mb-2">
                  {{
                    "You've made some changes. Are you sure you want to discard them?"
                      | translate
                  }}
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn-outline-cancel mr-2"
                  (click)="modal.close('cancel')"
                >
                  {{ "Discard" | translate }}
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="modal.close('save')"
                >
                  {{ "Save" | translate }}
                </button>
              </div>
            </ng-template>

            <!-- End remove store modal -->

            <button
              class="btn btn-back"
              (click)="prevStep()"
              [disabled]="isGeneratingProductHtml"
              *ngIf="!isFirstStep"
            >
              <i>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.05108 0.390979L0.384412 7.05764C0.263025 7.18445 0.167871 7.33398 0.104412 7.49764C-0.0289452 7.82226 -0.0289452 8.18636 0.104412 8.51098C0.167871 8.67465 0.263025 8.82417 0.384412 8.95098L7.05108 15.6176C7.1754 15.742 7.32298 15.8406 7.48541 15.9079C7.64784 15.9751 7.82193 16.0098 7.99775 16.0098C8.35281 16.0098 8.69334 15.8687 8.94441 15.6176C9.19548 15.3666 9.33653 15.026 9.33653 14.671C9.33653 14.3159 9.19548 13.9754 8.94441 13.7243L4.54441 9.33764L14.6644 9.33764C15.018 9.33764 15.3572 9.19717 15.6072 8.94712C15.8573 8.69707 15.9977 8.35793 15.9977 8.00431C15.9977 7.65069 15.8573 7.31155 15.6072 7.0615C15.3572 6.81145 15.018 6.67098 14.6644 6.67098L4.54441 6.67098L8.94441 2.28431C9.06938 2.16036 9.16858 2.01289 9.23627 1.85041C9.30396 1.68793 9.33881 1.51366 9.33881 1.33764C9.33881 1.16163 9.30396 0.987354 9.23627 0.824875C9.16858 0.662396 9.06938 0.51493 8.94441 0.390979C8.82046 0.266008 8.67299 0.166813 8.51051 0.0991217C8.34804 0.0314301 8.17376 -0.00342023 7.99775 -0.00342023C7.82173 -0.00342022 7.64746 0.0314301 7.48498 0.0991217C7.3225 0.166813 7.17503 0.266008 7.05108 0.390979Z"
                    fill="#616B77"
                  />
                </svg>
              </i>
              <span>{{ "Back" | translate }}</span>
            </button>
            <button
              class="btn btn-primary float-right"
              (click)="nextStep()"
              [disabled]="!canContinue || customPageIsLoading || customPageIsSaving || isGeneratingProductHtml"
              *ngIf="!isFinalStep"
            >
              {{ isGeneratingProductHtml ? ("Generating..." | translate) : ("Continue" | translate) }}
            </button>
            <button
              class="btn btn-primary float-right"
              [class.is-loading]="customPageIsSaving"
              [disabled]="
                isEditPage
                  ? customPageIsSaving || !editorIsReady || !hasUnsavedChanges
                  : customPageIsSaving || !editorIsReady
              "
              (click)="updateCustomPage($event, SAVE_BEHAVIOUR.SAVE)"
              *ngIf="isFinalStep"
            >
              {{ "Save" | translate }}
            </button>
            <div class="clear-both"></div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
